// Bibliothèque de pictogrammes pour les applications du portail.
// ~340 icônes Lucide organisées par catégories (voir iconCategories).
// Fichier généré : les clés kebab-case correspondent aux noms stockés en base.
import {
  FileText,
  File,
  Files,
  FileSpreadsheet,
  FileBarChart,
  FileCheck,
  FilePlus,
  FileSearch,
  FileSignature,
  FileArchive,
  FileCode,
  FileImage,
  FileVideo,
  FileAudio,
  FileClock,
  Clipboard,
  ClipboardList,
  ClipboardCheck,
  Notebook,
  NotebookPen,
  StickyNote,
  ScrollText,
  Book,
  BookOpen,
  BookMarked,
  BookText,
  Library,
  Newspaper,
  Pencil,
  PenLine,
  PenTool,
  Highlighter,
  Eraser,
  Paperclip,
  Archive,
  Folder,
  FolderOpen,
  FolderPlus,
  FolderSearch,
  FolderKanban,
  Printer,
  Scissors,
  Stamp,
  Save,
  Import,
  Mail,
  MailOpen,
  Inbox,
  Send,
  MessageSquare,
  MessageCircle,
  MessagesSquare,
  Phone,
  PhoneCall,
  Voicemail,
  AtSign,
  Rss,
  Megaphone,
  Radio,
  Podcast,
  Video,
  Webcam,
  Mic,
  Headphones,
  Share,
  Share2,
  Bell,
  BellRing,
  BellDot,
  Languages,
  Euro,
  DollarSign,
  PoundSterling,
  Banknote,
  Coins,
  PiggyBank,
  Receipt,
  Calculator,
  Wallet,
  CreditCard,
  Landmark,
  HandCoins,
  CircleDollarSign,
  BadgeEuro,
  BadgeDollarSign,
  Percent,
  BadgePercent,
  Scale,
  Briefcase,
  Building,
  Building2,
  Vault,
  Users,
  User,
  UserPlus,
  UserCheck,
  UserCog,
  UserSearch,
  Contact,
  BadgeCheck,
  Fingerprint,
  HeartHandshake,
  Handshake,
  PersonStanding,
  Baby,
  GraduationCap,
  School,
  Presentation,
  Award,
  Trophy,
  Medal,
  Crown,
  Smile,
  Frown,
  Meh,
  ThumbsUp,
  ThumbsDown,
  Factory,
  Warehouse,
  Forklift,
  Truck,
  Package,
  PackageOpen,
  PackageCheck,
  PackageSearch,
  Boxes,
  Container,
  Wrench,
  Hammer,
  Drill,
  Cog,
  Settings,
  Settings2,
  SlidersHorizontal,
  HardHat,
  Ruler,
  PencilRuler,
  Construction,
  TestTube,
  FlaskConical,
  Microscope,
  Atom,
  CircuitBoard,
  Bolt,
  Plug,
  PlugZap,
  BatteryCharging,
  Fuel,
  Recycle,
  Box,
  Code,
  Code2,
  Terminal,
  TerminalSquare,
  Braces,
  Binary,
  Database,
  HardDrive,
  Server,
  ServerCog,
  Cloud,
  UploadCloud,
  DownloadCloud,
  CloudCog,
  Network,
  Wifi,
  Router,
  Globe,
  Laptop,
  Monitor,
  MonitorSmartphone,
  Smartphone,
  Tablet,
  Keyboard,
  Mouse,
  Github,
  Gitlab,
  GitBranch,
  GitMerge,
  GitPullRequest,
  Bug,
  Shield,
  ShieldCheck,
  ShieldAlert,
  Lock,
  Unlock,
  Key,
  KeyRound,
  Webhook,
  QrCode,
  ScanLine,
  Bot,
  BrainCircuit,
  Brain,
  Sparkles,
  Wand2,
  Cpu,
  Link,
  Link2,
  ExternalLink,
  Download,
  Upload,
  RefreshCw,
  Repeat,
  Shuffle,
  LogIn,
  LogOut,
  Zap,
  BarChart,
  BarChart2,
  BarChart3,
  BarChart4,
  LineChart,
  AreaChart,
  PieChart,
  TrendingUp,
  TrendingDown,
  Gauge,
  Activity,
  Search,
  Filter,
  Eye,
  Target,
  Table,
  Table2,
  LayoutGrid,
  LayoutList,
  LayoutDashboard,
  Layers,
  Grid,
  List,
  Calendar,
  CalendarDays,
  CalendarCheck,
  CalendarClock,
  CalendarPlus,
  Clock,
  Timer,
  AlarmClock,
  Hourglass,
  ListTodo,
  ListChecks,
  Kanban,
  Workflow,
  GanttChartSquare,
  Milestone,
  Flag,
  Pin,
  Bookmark,
  BookmarkCheck,
  BookmarkPlus,
  Home,
  Edit,
  Check,
  Plus,
  Minus,
  X,
  Info,
  HelpCircle,
  AlertTriangle,
  Trash2,
  Loader2,
  ShoppingCart,
  ShoppingBag,
  ShoppingBasket,
  Store,
  Tag,
  Tags,
  Ticket,
  Gift,
  Barcode,
  PartyPopper,
  Star,
  StarHalf,
  Heart,
  Gem,
  MapPin,
  Map,
  Compass,
  Navigation,
  Route,
  Plane,
  Car,
  Bike,
  Bus,
  Train,
  Ship,
  Anchor,
  Rocket,
  Hotel,
  Mountain,
  Stethoscope,
  Pill,
  Syringe,
  Ambulance,
  HeartPulse,
  Dna,
  Accessibility,
  Cross,
  Thermometer,
  Palette,
  Brush,
  Image,
  Camera,
  Film,
  Clapperboard,
  Music,
  Gamepad2,
  Puzzle,
  Lightbulb,
  Coffee,
  Utensils,
  Apple,
  ChefHat,
  Shirt,
  Glasses,
  Umbrella,
  Sun,
  SunMedium,
  Moon,
  MoonStar,
  Snowflake,
  CloudRain,
  Wind,
  Flame,
  Leaf,
  Droplet,
  Sprout,
  Armchair,
  Bed,
  Lamp,
  DoorOpen,
  ChevronDown,
  ChevronUp,
  ChevronLeft,
  ChevronRight,
  ArrowRight,
  ArrowLeft,
  ArrowUp,
  ArrowDown,
  type LucideIcon
} from 'lucide-react';

const iconMap: Record<string, LucideIcon> = {
  'file-text': FileText,
  'file': File,
  'files': Files,
  'file-spreadsheet': FileSpreadsheet,
  'file-bar-chart': FileBarChart,
  'file-check': FileCheck,
  'file-plus': FilePlus,
  'file-search': FileSearch,
  'file-signature': FileSignature,
  'file-archive': FileArchive,
  'file-code': FileCode,
  'file-image': FileImage,
  'file-video': FileVideo,
  'file-audio': FileAudio,
  'file-clock': FileClock,
  'clipboard': Clipboard,
  'clipboard-list': ClipboardList,
  'clipboard-check': ClipboardCheck,
  'notebook': Notebook,
  'notebook-pen': NotebookPen,
  'sticky-note': StickyNote,
  'scroll-text': ScrollText,
  'book': Book,
  'book-open': BookOpen,
  'book-marked': BookMarked,
  'book-text': BookText,
  'library': Library,
  'newspaper': Newspaper,
  'pencil': Pencil,
  'pen-line': PenLine,
  'pen-tool': PenTool,
  'highlighter': Highlighter,
  'eraser': Eraser,
  'paperclip': Paperclip,
  'archive': Archive,
  'folder': Folder,
  'folder-open': FolderOpen,
  'folder-plus': FolderPlus,
  'folder-search': FolderSearch,
  'folder-kanban': FolderKanban,
  'printer': Printer,
  'scissors': Scissors,
  'stamp': Stamp,
  'save': Save,
  'import': Import,
  'mail': Mail,
  'mail-open': MailOpen,
  'inbox': Inbox,
  'send': Send,
  'message-square': MessageSquare,
  'message-circle': MessageCircle,
  'messages-square': MessagesSquare,
  'phone': Phone,
  'phone-call': PhoneCall,
  'voicemail': Voicemail,
  'at-sign': AtSign,
  'rss': Rss,
  'megaphone': Megaphone,
  'radio': Radio,
  'podcast': Podcast,
  'video': Video,
  'webcam': Webcam,
  'mic': Mic,
  'headphones': Headphones,
  'share': Share,
  'share-2': Share2,
  'bell': Bell,
  'bell-ring': BellRing,
  'bell-dot': BellDot,
  'languages': Languages,
  'euro': Euro,
  'dollar-sign': DollarSign,
  'pound-sterling': PoundSterling,
  'banknote': Banknote,
  'coins': Coins,
  'piggy-bank': PiggyBank,
  'receipt': Receipt,
  'calculator': Calculator,
  'wallet': Wallet,
  'credit-card': CreditCard,
  'landmark': Landmark,
  'hand-coins': HandCoins,
  'circle-dollar-sign': CircleDollarSign,
  'badge-euro': BadgeEuro,
  'badge-dollar-sign': BadgeDollarSign,
  'percent': Percent,
  'badge-percent': BadgePercent,
  'scale': Scale,
  'briefcase': Briefcase,
  'building': Building,
  'building-2': Building2,
  'vault': Vault,
  'users': Users,
  'user': User,
  'user-plus': UserPlus,
  'user-check': UserCheck,
  'user-cog': UserCog,
  'user-search': UserSearch,
  'contact': Contact,
  'badge-check': BadgeCheck,
  'fingerprint': Fingerprint,
  'heart-handshake': HeartHandshake,
  'handshake': Handshake,
  'person-standing': PersonStanding,
  'baby': Baby,
  'graduation-cap': GraduationCap,
  'school': School,
  'presentation': Presentation,
  'award': Award,
  'trophy': Trophy,
  'medal': Medal,
  'crown': Crown,
  'smile': Smile,
  'frown': Frown,
  'meh': Meh,
  'thumbs-up': ThumbsUp,
  'thumbs-down': ThumbsDown,
  'factory': Factory,
  'warehouse': Warehouse,
  'forklift': Forklift,
  'truck': Truck,
  'package': Package,
  'package-open': PackageOpen,
  'package-check': PackageCheck,
  'package-search': PackageSearch,
  'boxes': Boxes,
  'container': Container,
  'wrench': Wrench,
  'hammer': Hammer,
  'drill': Drill,
  'cog': Cog,
  'settings': Settings,
  'settings-2': Settings2,
  'sliders-horizontal': SlidersHorizontal,
  'hard-hat': HardHat,
  'ruler': Ruler,
  'pencil-ruler': PencilRuler,
  'construction': Construction,
  'test-tube': TestTube,
  'flask-conical': FlaskConical,
  'microscope': Microscope,
  'atom': Atom,
  'circuit-board': CircuitBoard,
  'bolt': Bolt,
  'plug': Plug,
  'plug-zap': PlugZap,
  'battery-charging': BatteryCharging,
  'fuel': Fuel,
  'recycle': Recycle,
  'box': Box,
  'code': Code,
  'code-2': Code2,
  'terminal': Terminal,
  'terminal-square': TerminalSquare,
  'braces': Braces,
  'binary': Binary,
  'database': Database,
  'hard-drive': HardDrive,
  'server': Server,
  'server-cog': ServerCog,
  'cloud': Cloud,
  'upload-cloud': UploadCloud,
  'download-cloud': DownloadCloud,
  'cloud-cog': CloudCog,
  'network': Network,
  'wifi': Wifi,
  'router': Router,
  'globe': Globe,
  'laptop': Laptop,
  'monitor': Monitor,
  'monitor-smartphone': MonitorSmartphone,
  'smartphone': Smartphone,
  'tablet': Tablet,
  'keyboard': Keyboard,
  'mouse': Mouse,
  'github': Github,
  'gitlab': Gitlab,
  'git-branch': GitBranch,
  'git-merge': GitMerge,
  'git-pull-request': GitPullRequest,
  'bug': Bug,
  'shield': Shield,
  'shield-check': ShieldCheck,
  'shield-alert': ShieldAlert,
  'lock': Lock,
  'unlock': Unlock,
  'key': Key,
  'key-round': KeyRound,
  'webhook': Webhook,
  'qr-code': QrCode,
  'scan-line': ScanLine,
  'bot': Bot,
  'brain-circuit': BrainCircuit,
  'brain': Brain,
  'sparkles': Sparkles,
  'wand-2': Wand2,
  'cpu': Cpu,
  'link': Link,
  'link-2': Link2,
  'external-link': ExternalLink,
  'download': Download,
  'upload': Upload,
  'refresh-cw': RefreshCw,
  'repeat': Repeat,
  'shuffle': Shuffle,
  'log-in': LogIn,
  'log-out': LogOut,
  'zap': Zap,
  'bar-chart': BarChart,
  'bar-chart-2': BarChart2,
  'bar-chart-3': BarChart3,
  'bar-chart-4': BarChart4,
  'line-chart': LineChart,
  'area-chart': AreaChart,
  'pie-chart': PieChart,
  'trending-up': TrendingUp,
  'trending-down': TrendingDown,
  'gauge': Gauge,
  'activity': Activity,
  'search': Search,
  'filter': Filter,
  'eye': Eye,
  'target': Target,
  'table': Table,
  'table-2': Table2,
  'layout-grid': LayoutGrid,
  'layout-list': LayoutList,
  'layout-dashboard': LayoutDashboard,
  'layers': Layers,
  'grid': Grid,
  'list': List,
  'calendar': Calendar,
  'calendar-days': CalendarDays,
  'calendar-check': CalendarCheck,
  'calendar-clock': CalendarClock,
  'calendar-plus': CalendarPlus,
  'clock': Clock,
  'timer': Timer,
  'alarm-clock': AlarmClock,
  'hourglass': Hourglass,
  'list-todo': ListTodo,
  'list-checks': ListChecks,
  'kanban': Kanban,
  'workflow': Workflow,
  'gantt-chart-square': GanttChartSquare,
  'milestone': Milestone,
  'flag': Flag,
  'pin': Pin,
  'bookmark': Bookmark,
  'bookmark-check': BookmarkCheck,
  'bookmark-plus': BookmarkPlus,
  'home': Home,
  'edit': Edit,
  'check': Check,
  'plus': Plus,
  'minus': Minus,
  'x': X,
  'info': Info,
  'help-circle': HelpCircle,
  'alert-triangle': AlertTriangle,
  'trash-2': Trash2,
  'loader-2': Loader2,
  'shopping-cart': ShoppingCart,
  'shopping-bag': ShoppingBag,
  'shopping-basket': ShoppingBasket,
  'store': Store,
  'tag': Tag,
  'tags': Tags,
  'ticket': Ticket,
  'gift': Gift,
  'barcode': Barcode,
  'party-popper': PartyPopper,
  'star': Star,
  'star-half': StarHalf,
  'heart': Heart,
  'gem': Gem,
  'map-pin': MapPin,
  'map': Map,
  'compass': Compass,
  'navigation': Navigation,
  'route': Route,
  'plane': Plane,
  'car': Car,
  'bike': Bike,
  'bus': Bus,
  'train': Train,
  'ship': Ship,
  'anchor': Anchor,
  'rocket': Rocket,
  'hotel': Hotel,
  'mountain': Mountain,
  'stethoscope': Stethoscope,
  'pill': Pill,
  'syringe': Syringe,
  'ambulance': Ambulance,
  'heart-pulse': HeartPulse,
  'dna': Dna,
  'accessibility': Accessibility,
  'cross': Cross,
  'thermometer': Thermometer,
  'palette': Palette,
  'brush': Brush,
  'image': Image,
  'camera': Camera,
  'film': Film,
  'clapperboard': Clapperboard,
  'music': Music,
  'gamepad-2': Gamepad2,
  'puzzle': Puzzle,
  'lightbulb': Lightbulb,
  'coffee': Coffee,
  'utensils': Utensils,
  'apple': Apple,
  'chef-hat': ChefHat,
  'shirt': Shirt,
  'glasses': Glasses,
  'umbrella': Umbrella,
  'sun': Sun,
  'sun-medium': SunMedium,
  'moon': Moon,
  'moon-star': MoonStar,
  'snowflake': Snowflake,
  'cloud-rain': CloudRain,
  'wind': Wind,
  'flame': Flame,
  'leaf': Leaf,
  'droplet': Droplet,
  'sprout': Sprout,
  'armchair': Armchair,
  'bed': Bed,
  'lamp': Lamp,
  'door-open': DoorOpen,
  'chevron-down': ChevronDown,
  'chevron-up': ChevronUp,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'arrow-right': ArrowRight,
  'arrow-left': ArrowLeft,
  'arrow-up': ArrowUp,
  'arrow-down': ArrowDown,
  // Alias historiques (valeurs déjà présentes en base)
  calendarDays: CalendarDays,
  trash: Trash2,
  loader: Loader2,
};

// Catégories pour le sélecteur d'icônes du paramétrage
export const iconCategories: { label: string; icons: string[] }[] = [
  {
    label: 'Bureautique & documents',
    icons: ['file-text', 'file', 'files', 'file-spreadsheet', 'file-bar-chart', 'file-check', 'file-plus', 'file-search', 'file-signature', 'file-archive', 'file-code', 'file-image', 'file-video', 'file-audio', 'file-clock', 'clipboard', 'clipboard-list', 'clipboard-check', 'notebook', 'notebook-pen', 'sticky-note', 'scroll-text', 'book', 'book-open', 'book-marked', 'book-text', 'library', 'newspaper', 'pencil', 'pen-line', 'pen-tool', 'highlighter', 'eraser', 'paperclip', 'archive', 'folder', 'folder-open', 'folder-plus', 'folder-search', 'folder-kanban', 'printer', 'scissors', 'stamp', 'save', 'import'],
  },
  {
    label: 'Communication',
    icons: ['mail', 'mail-open', 'inbox', 'send', 'message-square', 'message-circle', 'messages-square', 'phone', 'phone-call', 'voicemail', 'at-sign', 'rss', 'megaphone', 'radio', 'podcast', 'video', 'webcam', 'mic', 'headphones', 'share', 'share-2', 'bell', 'bell-ring', 'bell-dot', 'languages'],
  },
  {
    label: 'Finance & gestion',
    icons: ['euro', 'dollar-sign', 'pound-sterling', 'banknote', 'coins', 'piggy-bank', 'receipt', 'calculator', 'wallet', 'credit-card', 'landmark', 'hand-coins', 'circle-dollar-sign', 'badge-euro', 'badge-dollar-sign', 'percent', 'badge-percent', 'scale', 'briefcase', 'building', 'building-2', 'vault'],
  },
  {
    label: 'RH & personnes',
    icons: ['users', 'user', 'user-plus', 'user-check', 'user-cog', 'user-search', 'contact', 'badge-check', 'fingerprint', 'heart-handshake', 'handshake', 'person-standing', 'baby', 'graduation-cap', 'school', 'presentation', 'award', 'trophy', 'medal', 'crown', 'smile', 'frown', 'meh', 'thumbs-up', 'thumbs-down'],
  },
  {
    label: 'Industrie & logistique',
    icons: ['factory', 'warehouse', 'forklift', 'truck', 'package', 'package-open', 'package-check', 'package-search', 'boxes', 'container', 'wrench', 'hammer', 'drill', 'cog', 'settings', 'settings-2', 'sliders-horizontal', 'hard-hat', 'ruler', 'pencil-ruler', 'construction', 'test-tube', 'flask-conical', 'microscope', 'atom', 'circuit-board', 'bolt', 'plug', 'plug-zap', 'battery-charging', 'fuel', 'recycle', 'box'],
  },
  {
    label: 'Tech & développement',
    icons: ['code', 'code-2', 'terminal', 'terminal-square', 'braces', 'binary', 'database', 'hard-drive', 'server', 'server-cog', 'cloud', 'upload-cloud', 'download-cloud', 'cloud-cog', 'network', 'wifi', 'router', 'globe', 'laptop', 'monitor', 'monitor-smartphone', 'smartphone', 'tablet', 'keyboard', 'mouse', 'github', 'gitlab', 'git-branch', 'git-merge', 'git-pull-request', 'bug', 'shield', 'shield-check', 'shield-alert', 'lock', 'unlock', 'key', 'key-round', 'webhook', 'qr-code', 'scan-line', 'bot', 'brain-circuit', 'brain', 'sparkles', 'wand-2', 'cpu', 'link', 'link-2', 'external-link', 'download', 'upload', 'refresh-cw', 'repeat', 'shuffle', 'log-in', 'log-out', 'zap'],
  },
  {
    label: 'Données & analyse',
    icons: ['bar-chart', 'bar-chart-2', 'bar-chart-3', 'bar-chart-4', 'line-chart', 'area-chart', 'pie-chart', 'trending-up', 'trending-down', 'gauge', 'activity', 'search', 'filter', 'eye', 'target', 'table', 'table-2', 'layout-grid', 'layout-list', 'layout-dashboard', 'layers', 'grid', 'list'],
  },
  {
    label: 'Organisation & temps',
    icons: ['calendar', 'calendar-days', 'calendar-check', 'calendar-clock', 'calendar-plus', 'clock', 'timer', 'alarm-clock', 'hourglass', 'list-todo', 'list-checks', 'kanban', 'workflow', 'gantt-chart-square', 'milestone', 'flag', 'pin', 'bookmark', 'bookmark-check', 'bookmark-plus', 'home', 'edit', 'check', 'plus', 'minus', 'x', 'info', 'help-circle', 'alert-triangle', 'trash-2', 'loader-2'],
  },
  {
    label: 'Commerce',
    icons: ['shopping-cart', 'shopping-bag', 'shopping-basket', 'store', 'tag', 'tags', 'ticket', 'gift', 'barcode', 'party-popper', 'star', 'star-half', 'heart', 'gem'],
  },
  {
    label: 'Lieux & transport',
    icons: ['map-pin', 'map', 'compass', 'navigation', 'route', 'plane', 'car', 'bike', 'bus', 'train', 'ship', 'anchor', 'rocket', 'hotel', 'mountain'],
  },
  {
    label: 'Santé & sécurité',
    icons: ['stethoscope', 'pill', 'syringe', 'ambulance', 'heart-pulse', 'dna', 'accessibility', 'cross', 'thermometer'],
  },
  {
    label: 'Divers',
    icons: ['palette', 'brush', 'image', 'camera', 'film', 'clapperboard', 'music', 'gamepad-2', 'puzzle', 'lightbulb', 'coffee', 'utensils', 'apple', 'chef-hat', 'shirt', 'glasses', 'umbrella', 'sun', 'sun-medium', 'moon', 'moon-star', 'snowflake', 'cloud-rain', 'wind', 'flame', 'leaf', 'droplet', 'sprout', 'armchair', 'bed', 'lamp', 'door-open', 'chevron-down', 'chevron-up', 'chevron-left', 'chevron-right', 'arrow-right', 'arrow-left', 'arrow-up', 'arrow-down'],
  },
];

export function getIcon(iconName: string): LucideIcon {
  return iconMap[iconName] || Link;
}

export const availableIcons = iconCategories.flatMap((c) => c.icons);
